// reducer.js
import * as actionTypes from "./actionsTypes";

const initialState = {
  currentPage: 1,
  value: "",
  sortField: "date_souscription",
  order: "desc",
};

const rootReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_CURRENT_PAGE_PARTICIPATION:
      return {
        ...state,
        currentPage: action.payload
      };
    case actionTypes.SET_VALUE_PARTICIPATION:
      return {
        ...state,
        value: action.payload
      };
    case actionTypes.SET_SORT_FIELD_PARTICIPATION:
      return {
        ...state,
        sortField: action.payload
      };
    case actionTypes.SET_ORDER_PARTICIPATION:
      return {
        ...state,
        order: action.payload
      };
    default:
      return state;
  }
};

export default rootReducer;
